// extracted by mini-css-extract-plugin
export default {"container":"InterestProducts_container__BJPSn","content":"InterestProducts_content__SiNP+","list":"InterestProducts_list__+gZE4"};